export default __webpack_public_path__ + "static/media/sub_notification.30761756.wav";